import { render, staticRenderFns } from "./Questionsbank.vue?vue&type=template&id=5dd76373&scoped=true&"
import script from "./Questionsbank.vue?vue&type=script&lang=js&"
export * from "./Questionsbank.vue?vue&type=script&lang=js&"
import style0 from "./Questionsbank.vue?vue&type=style&index=0&id=5dd76373&scoped=true&lang=css&"
import style1 from "./Questionsbank.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd76373",
  null
  
)

export default component.exports